// imports
import React from 'react';

// interfaces / types / consts
interface ImageProps {
  src: string;
  alt?: string;
  width?: string;
  height?: string;
  className?: string;
}

// exports
export function Image(props: ImageProps): React.ReactElement {
  const {
    src, className, alt, width, height
  } = props;
  return (<img className={className} src={src} alt={alt} width={width} height={height} />);
}

export function ImageCover(props: ImageProps): React.ReactElement {
  const {
    src, className, alt, width, height
  } = props;
  return (<img src={src} alt={alt} width={width} height={height} className={`${className} image-cover`} />);
}

export default { Image, ImageCover };

// default props
Image.defaultProps = {
  alt: 'im-bg',
  width: 'auto',
  className: '',
  height: 'auto'
};

ImageCover.defaultProps = {
  className: '',
  width: 'auto',
  height: 'auto',
  alt: 'im-cover'
};
